import { defer } from 'frontend/utils/timing';

export function lockScroll(shouldLock: boolean): void {
  defer(() => {
    if (shouldLock) {
      document.body.classList.add('locked');
    } else {
      document.body.classList.remove('locked');
    }
  });
}

export function smoothScrollTo(
  yPosition: number | HTMLElement,
  container?: HTMLElement,
): Promise<void> {
  let yPos: number;
  if (typeof yPosition === 'number') {
    yPos = yPosition;
  }
  if (yPosition instanceof HTMLElement) {
    yPos = yPosition.offsetTop;
  }
  return new Promise(resolve => {
    if (!container && !window) {
      resolve();
    } else {
      try {
        let prevScrollPos: number;
        // Some browsers don't support object params
        if (container) {
          container.scrollTo({
            top: yPos,
            behavior: 'smooth',
          });
          prevScrollPos = container.scrollTop;
        } else {
          window.scroll({
            top: yPos,
            behavior: 'smooth',
          });
          prevScrollPos = window.pageYOffset;
        }
        const scrollListener = setInterval(() => {
          const currentScrollPos = container ? container.scrollTop : window.pageYOffset;
          if (currentScrollPos === prevScrollPos) {
            clearInterval(scrollListener);
            resolve();
          } else {
            prevScrollPos = currentScrollPos;
          }
        }, 50);
      } catch (e) {
        if (container) {
          container.scrollTop = yPos;
        } else {
          window.scroll(0, yPos);
        }
        resolve();
      }
    }
  });
}

export async function scrollToAnchorName(name: string): Promise<void> {
  const targetSection: HTMLElement | null = document.querySelector(`[name="${name}"]`);
  if (targetSection) {
    const rect = targetSection.getBoundingClientRect();
    await smoothScrollTo(rect.top + window.pageYOffset);
  }
}
